import dayjs from "dayjs";

export const PRESETS = {
  PREVIOUS_DAY: "previousDay",
  PREVIOUS_MONTH: "previousMonth",
  TWO_MONTHS_PRIOR: "twoMonthsPrior",
  THIS_MONTH: "thisMonth",
  LAST_7_DAYS: "last7Days",
  CUSTOM: "custom"
};

const fmt = (d) => d.format("YYYY-MM-DD");

export const getPreviousDayRange = () => {
  const yesterday = dayjs().subtract(1, "day");
  return {
    startDate: fmt(yesterday),
    endDate: fmt(yesterday)
  };
};

export const getPreviousMonthRange = () => {
  const lastMonth = dayjs().subtract(1, "month");
  return {
    startDate: fmt(lastMonth.startOf("month")),
    endDate: fmt(lastMonth.endOf("month"))
  };
};

export const getTwoMonthsPriorRange = () => {
  const twoMonthsAgo = dayjs().subtract(2, "month");
  return {
    startDate: fmt(twoMonthsAgo.startOf("month")),
    endDate: fmt(twoMonthsAgo.endOf("month"))
  };
};

export const getThisMonthRange = () => {
  const now = dayjs();
  return {
    startDate: fmt(now.startOf("month")),
    endDate: fmt(now)
  };
};

export const getLast7DaysRange = () => {
  const now = dayjs();
  return {
    startDate: fmt(now.subtract(6, "day")),
    endDate: fmt(now)
  };
};

export const getRangeForPreset = (preset) => {
  switch (preset) {
    case PRESETS.PREVIOUS_DAY:
      return getPreviousDayRange();
    case PRESETS.TWO_MONTHS_PRIOR:
      return getTwoMonthsPriorRange();
    case PRESETS.THIS_MONTH:
      return getThisMonthRange();
    case PRESETS.LAST_7_DAYS:
      return getLast7DaysRange();
    case PRESETS.PREVIOUS_MONTH:
    default:
      return getPreviousMonthRange();
  }
};
